'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = mapSelf;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function mirror(o) {
  return o;
}

function mapSelf(children) {
  // return ReactFragment
  return _react2['default'].Children.map(children, mirror);
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/rc-util/lib/Children/mapSelf.js
// module id = 369
// module chunks = 0